import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Field } from 'redux-form'
import Mixin from 'components/common/Mixin'
import Link from 'components/common/Link/Link'
import { Input } from 'components/common/FormElements/Input'

const CheckboxFieldWithLink = ({ path: linkUrl, linkLabel, ...props }) =>
  <Input margin="0 0 30px 0" { ...props }>
    <TermsLink data-at-terms-link bolder to={ linkUrl } target="_blank">{ linkLabel }</TermsLink>
  </Input>

CheckboxFieldWithLink.propTypes = {
  linkLabel: PropTypes.string,
  path: PropTypes.string
}

const TermsAgreement = ({ form, ...props }) =>
  <TermsAgreementWrapper>
    <Title>Agreement*</Title>
    <Field inline { ...props } { ...form.termsAgreement } component={ CheckboxFieldWithLink } />
  </TermsAgreementWrapper>

TermsAgreement.propTypes = {
  form: PropTypes.shape({
    termsAgreement: PropTypes.shape()
  }),
  handleClick: PropTypes.func,
  path: PropTypes.string
}

export default TermsAgreement

const TermsAgreementWrapper = styled.div`
  ${Mixin.responsive('margin-bottom', '40px', '36px')}

  & [data-at-checkbox-error-message] {
    padding: 0;
    position: initial;
    display: block;
    margin-top: 7px;
  }
`

const TermsLink = styled(Link)`
  display: inline;
  padding-left: 5px;
  line-height: 21px;
  vertical-align: top;
`

const Title = styled.p`
  font-size: 16px;
`
